
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import store from "@/store";
import router from "@/router";
import NativeClient from "@/client/native-client";
import {
  PantryFridgeRoomData,
  PantryFridgeImageData,
  PantryFridgeAreaImageInfo,
  PantryFridgeListInfo,
  PantryFridgeRoomCreateData,
  PantryFridgeDummyRoomData,
  FRIDGE_ROOM_ID_TYPE,
  FRIDGE_AREA_ID_TYPE,
  FREEZER_AREA_ID_TYPE,
  VEGETABLE_AREA_ID_TYPE,
  FRIDGE_INFO_DOOR_ID_TYPE,
  MAX_FRIDGE_ROOM,
  IMAGE_ORIENTATION_TYPE,
  PantryCameraDateData,
  FridgeCameraRoomInfo,
  CAMERA_ROOM_FREEZER_TRAY,
} from "@/types/pantry";
import PantryImageView from "@/components/pantry/PantryImageView.vue";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import PantryImageSelectView from "@/components/pantry/PantryImageSelectView.vue";
import PantryCameraDateDialog from "@/components/pantry/PantryCameraDateDialog.vue";
import PantryUtil from "@/utils/pantry-util";
import CommonUtil from "@/utils/common-utils";
import CommonDesignDialog from "@/components/common/CommonDesignDialog.vue";
export default defineComponent({
  name: "PantryCameraPage",
  components: {
    CommonDesignDialog,
    PantryImageView,
    PantryImageSelectView,
    PantryCameraDateDialog
  },
  setup() {
    const ERROR_BUTTON_LABEL = "OK";
    const WAIT_TIMER_DATE_CHANGE = 250;
    const IMAGE_MARGIN_VALUE = "0.8rem";
    const selectRoomId = ref(FRIDGE_ROOM_ID_TYPE.DOOR);
    const fridgeImageList = ref(Array<PantryFridgeRoomData>());
    const isShowCameraDateDialog = ref(false);
    const imageUpdate = ref(true);
    const dateSelectId = ref(-1);
    const dateRoomId = ref(-1);
    const dateAreaId = ref(-1);
    const dateList = ref(Array<PantryCameraDateData>());
    const cameraRoomInfo = ref(new FridgeCameraRoomInfo());

    /** APIリクエスト時のエラーハンドル */
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();
    const getApplianceId = () => {
      let applianceId = String(router.currentRoute.value.query.applianceId);
      let result = "";
      if (applianceId == 'undefined') {
        NativeClient.sendDebugLog("getApplianceId empty");
        applianceId = ""
      } else {
        result = decodeURIComponent(applianceId);
      }
      return result;
    };
    const getRoomId = () => {
      const roomId = String(router.currentRoute.value.query.roomId);
      let result = FRIDGE_ROOM_ID_TYPE.DOOR;
      if (roomId == 'undefined') {
        NativeClient.sendDebugLog("getRoomId empty");
        result = FRIDGE_ROOM_ID_TYPE.DOOR;
      } else {
        switch (roomId) {
          case "0":
            result = FRIDGE_ROOM_ID_TYPE.FRIDGE;
            break;
          case "1":
            result = FRIDGE_ROOM_ID_TYPE.FREEZER;
            break;
          case "2":
            result = FRIDGE_ROOM_ID_TYPE.VEGETABLE;
            break;
          case "3":
            result = FRIDGE_ROOM_ID_TYPE.DOOR;
            break;
        }
      }
      return result;
    };
    const applianceId = getApplianceId();
    selectRoomId.value = getRoomId();
    NativeClient.sendDebugLog("PantryDetailPage applianceId=" + applianceId + " selectRoomId=" + selectRoomId.value);
    const onClickCloseCamera = () => {
      // モーダル表示の場合はNativeで画面を終了する
      NativeClient.pageClose();
    };
    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value >= 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };
    const updateListKey = ref(0);
    const updateList = () => {
      if (updateListKey.value >= 100) {
        updateListKey.value = 0;
      } else {
        updateListKey.value++;
      }
    };
    const updateDateDialogKey = ref(0);
    const updateDateDialog = () => {
      if (updateDateDialogKey.value >= 100) {
        updateDateDialogKey.value = 0;
      } else {
        updateDateDialogKey.value++;
      }
    };
    const setImaegeMargin = (data: PantryFridgeAreaImageInfo) => {
      const orientation = data.orientation;
      if (orientation == IMAGE_ORIENTATION_TYPE.HORIZONTAL) {
        data.marginTop = "auto";
        data.marginBottom = "auto";
        if (data.roomId == FRIDGE_ROOM_ID_TYPE.DOOR && data.areaId == FRIDGE_AREA_ID_TYPE.LEFT_DOOR ||
            data.roomId == FRIDGE_ROOM_ID_TYPE.FREEZER && data.areaId == FREEZER_AREA_ID_TYPE.UPPER_LEFT_TRAY) {
          data.marginRight = IMAGE_MARGIN_VALUE;
        } else if (data.roomId == FRIDGE_ROOM_ID_TYPE.DOOR && data.areaId == FRIDGE_AREA_ID_TYPE.RIGHT_DOOR ||
            data.roomId == FRIDGE_ROOM_ID_TYPE.FREEZER && data.areaId == FREEZER_AREA_ID_TYPE.UPPER_RIGHT_TRAY) {
          data.marginLeft = IMAGE_MARGIN_VALUE;
        }
      } else {
        data.marginTop = "auto";
        data.marginBottom = "auto";
        if (data.totalSize >= 2) {
          if (data.position == 0) {
            data.marginBottom = IMAGE_MARGIN_VALUE;
          } else if (data.position == data.totalSize - 1) {
            data.marginTop = IMAGE_MARGIN_VALUE;
          } else {
            data.marginTop = IMAGE_MARGIN_VALUE;
            data.marginBottom = IMAGE_MARGIN_VALUE;
          }
        }
        if (data.roomId == FRIDGE_ROOM_ID_TYPE.FREEZER &&
          cameraRoomInfo.value.isUmamori == true) {
          if (cameraRoomInfo.value.numOfFreezerShelves >= 3 && data.areaId == FREEZER_AREA_ID_TYPE.MEDIAM_TRAY ||
            cameraRoomInfo.value.numOfFreezerShelves == 2 && data.areaId == FREEZER_AREA_ID_TYPE.LOWER_TRAY) {
            data.marginTop = "1.6rem";
          }
        }
      }
      NativeClient.sendDebugLog("PantryCameraPage setImaegeMargin data=" + JSON.stringify(data));
    };

    const setAreaMap = (image: PantryFridgeImageData, map: Map<number, Array<PantryFridgeImageData>>,  imageMap: Map<number, PantryFridgeImageData>) => {
      if (image.areaId != -1) {
        let imageList = map.get(image.areaId);
        if (imageList == null) {
          imageList = new Array<PantryFridgeImageData>();
        }
        imageList.push(image);
        map.set(image.areaId, imageList);
        // 対象画像を1つのみ指定
        const mapImage = imageMap.get(image.areaId);
        if (mapImage == null) {
          imageMap.set(image.areaId, image);
        }
      }
    };

    const getDoorImageList = (roomId: number, areaImageList: Array<PantryFridgeImageData>) => {
      const roomImages = new Array<PantryFridgeImageData>();
      const areaImageMap = new Map<number, PantryFridgeImageData>();
      const areaMap = new Map<number, Array<PantryFridgeImageData>>();
      const checkMap = new Map<number, boolean>();
      if (cameraRoomInfo.value.reizoDoorTypeId == FRIDGE_INFO_DOOR_ID_TYPE.FRENCH_DOOR) {
        checkMap.set(FRIDGE_AREA_ID_TYPE.LEFT_DOOR, false);
        checkMap.set(FRIDGE_AREA_ID_TYPE.RIGHT_DOOR, false);
      }
      for (const image of areaImageList) {
        if (image) {
          let isTarget = false;
          if (cameraRoomInfo.value.reizoDoorTypeId == FRIDGE_INFO_DOOR_ID_TYPE.FRENCH_DOOR) {
            switch (image.areaId) {
              case FRIDGE_AREA_ID_TYPE.LEFT_DOOR:
              case FRIDGE_AREA_ID_TYPE.RIGHT_DOOR:
                NativeClient.sendDebugLog("PantryCameraPage getDoorImageList FRENTCH_DOOR images=" + JSON.stringify(image));
                image.orientation = IMAGE_ORIENTATION_TYPE.HORIZONTAL;
                roomImages.push(image);
                isTarget = true;
                checkMap.delete(image.areaId);
                break;
            }
          } else if (cameraRoomInfo.value.reizoDoorTypeId == FRIDGE_INFO_DOOR_ID_TYPE.RIGHT_OPEN_DOOR) {
            if (image.areaId == FRIDGE_AREA_ID_TYPE.RIGHT_DOOR) {
              NativeClient.sendDebugLog("PantryCameraPage getDoorImageList RIGHT_DOOR images=" + JSON.stringify(image));
              roomImages.push(image);
              isTarget = true;
            }
          } else if (cameraRoomInfo.value.reizoDoorTypeId == FRIDGE_INFO_DOOR_ID_TYPE.LEFT_OPEN_DOOR) {
            if (image.areaId == FRIDGE_AREA_ID_TYPE.LEFT_DOOR) {
              NativeClient.sendDebugLog("PantryCameraPage getDoorImageList LEFT_DOOR images=" + JSON.stringify(image));
              roomImages.push(image);
              isTarget = true;
            }
          }
          if (isTarget) {
            setAreaMap(image, areaMap, areaImageMap);
          }
        }
      }
      if (checkMap.size >= 1) {
        let i = roomImages.length;
        for (const key of checkMap.keys()) {
          const image = new PantryFridgeImageData(i, roomId, null, null);
          image.orientation = IMAGE_ORIENTATION_TYPE.HORIZONTAL;
          image.areaId = key;
          i++;
          setAreaMap(image, areaMap, areaImageMap);
          roomImages.push(image);
        }
      }
      const roomItem = new PantryFridgeRoomData(roomId, areaMap, areaImageMap);
      return roomItem;
    };

    const getFridgeImageList = (roomId: number, areaImageList: Array<PantryFridgeImageData>) => {
      const roomImages = new Array<PantryFridgeImageData>();
      const areaImageMap = new Map<number, PantryFridgeImageData>();
      const areaMap = new Map<number, Array<PantryFridgeImageData>>();
      for (const image of areaImageList) {
        if (image) {
          let isTarget = false;
          switch (image.areaId) {
            case FRIDGE_AREA_ID_TYPE.FRONT_SHELF:
              NativeClient.sendDebugLog("PantryCameraPage getFridgeImageList images=" + JSON.stringify(image));
              roomImages.push(image);
              isTarget = true;
              break;
          }
          if (isTarget) {
            setAreaMap(image, areaMap, areaImageMap);
          }
        }
      }
      const roomItem = new PantryFridgeRoomData(roomId, areaMap, areaImageMap);
      return roomItem;
    };

    const getFreezerImageList = (roomId: number, areaImageList: Array<PantryFridgeImageData>) => {
      const roomImages = new Array<PantryFridgeImageData>();
      const areaImageMap = new Map<number, PantryFridgeImageData>();
      const areaMap = new Map<number, Array<PantryFridgeImageData>>();
      const checkMap = new Map<number, boolean>();
      if (cameraRoomInfo.value.isUmamori) {
        checkMap.set(FREEZER_AREA_ID_TYPE.UPPER_LEFT_TRAY, false);
        checkMap.set(FREEZER_AREA_ID_TYPE.UPPER_RIGHT_TRAY, false);
      } else {
        checkMap.set(FREEZER_AREA_ID_TYPE.UPPER_TRAY, false);
      }
      if (cameraRoomInfo.value.numOfFreezerShelves >= 3) {
        checkMap.set(FREEZER_AREA_ID_TYPE.MEDIAM_TRAY, false);
      } 
      checkMap.set(FREEZER_AREA_ID_TYPE.LOWER_TRAY, false);
      for (const image of areaImageList) {
        if (image) {
          let isTarget = false;
          switch (image.areaId) {
            case FREEZER_AREA_ID_TYPE.UPPER_LEFT_TRAY:
            case FREEZER_AREA_ID_TYPE.UPPER_RIGHT_TRAY:
              NativeClient.sendDebugLog("PantryCameraPage getFreezerImageList images=" + JSON.stringify(image));
              image.orientation = IMAGE_ORIENTATION_TYPE.HORIZONTAL;
              roomImages.push(image);
              isTarget = true;
              break;
            case FREEZER_AREA_ID_TYPE.UPPER_TRAY:
            case FREEZER_AREA_ID_TYPE.MEDIAM_TRAY:
            case FREEZER_AREA_ID_TYPE.LOWER_TRAY:
              NativeClient.sendDebugLog("PantryCameraPage getFreezerImageList images=" + JSON.stringify(image));
              roomImages.push(image);
              isTarget = true;
              break;
          }
          if (isTarget) {
            checkMap.delete(image.areaId);
            setAreaMap(image, areaMap, areaImageMap);
          }
        }
      }
      if (checkMap.size >= 1) {
        let i = roomImages.length;
        for (const key of checkMap.keys()) {
          const image = new PantryFridgeImageData(i, roomId, null, null);
          if (key == FREEZER_AREA_ID_TYPE.UPPER_LEFT_TRAY || key == FREEZER_AREA_ID_TYPE.UPPER_RIGHT_TRAY) {
            image.orientation = IMAGE_ORIENTATION_TYPE.HORIZONTAL;
          }
          image.areaId = key;
          i++;
          setAreaMap(image, areaMap, areaImageMap);
        }
      }
      const roomItem = new PantryFridgeRoomData(roomId, areaMap, areaImageMap);
      return roomItem;
    };

    const getVegetableImageList = (roomId: number, areaImageList: Array<PantryFridgeImageData>) => {
      const roomImages = new Array<PantryFridgeImageData>();
      const areaImageMap = new Map<number, PantryFridgeImageData>();
      const areaMap = new Map<number, Array<PantryFridgeImageData>>();
      const checkMap = new Map<number, boolean>();
      checkMap.set(VEGETABLE_AREA_ID_TYPE.UPPER_TRAY, false);
      checkMap.set(VEGETABLE_AREA_ID_TYPE.LOWER_TRAY, false);
      checkMap.set(VEGETABLE_AREA_ID_TYPE.LOWER_POCKET_TRAY, false);
      for (const image of areaImageList) {
        if (image) {
          let isTarget = false;
          switch (image.areaId) {
            case VEGETABLE_AREA_ID_TYPE.UPPER_TRAY:
            case VEGETABLE_AREA_ID_TYPE.LOWER_POCKET_TRAY:
            case VEGETABLE_AREA_ID_TYPE.LOWER_TRAY:
              NativeClient.sendDebugLog("PantryCameraPage getVegetableImageList images=" + JSON.stringify(image));
              roomImages.push(image);
              isTarget = true;
              break;
          }
          if (isTarget) {
            checkMap.delete(image.areaId);
            setAreaMap(image, areaMap, areaImageMap);
          }
        }
      }
      if (checkMap.size >= 1) {
        let i = roomImages.length;
        for (const key of checkMap.keys()) {
          const image = new PantryFridgeImageData(i, roomId, null, null);
          image.areaId = key;
          i++;
          setAreaMap(image, areaMap, areaImageMap);
        }
      }
      const roomItem = new PantryFridgeRoomData(roomId, areaMap, areaImageMap);
      return roomItem;
    };

    const roomsList = () => {
      const imageInfoList:PantryFridgeListInfo = store.getters["pantry/getPantryFridgeListInfo"];
      NativeClient.sendDebugLog(
        "PantryCameraPage roomsList result=" + JSON.stringify(imageInfoList)
      );
      let i = 0;
      const rooms = new Array<PantryFridgeRoomData>();
      if (imageInfoList != null && imageInfoList.rooms != null) {
        cameraRoomInfo.value.reizoDoorTypeId = imageInfoList.reizoDoorTypeId;
        cameraRoomInfo.value.numOfFreezerShelves = imageInfoList.numOfFreezerShelves;
        cameraRoomInfo.value.isUmamori = imageInfoList.isUmamori;
        cameraRoomInfo.value.numOfVegetableShelves = imageInfoList.numOfVegetableShelves;
        if (imageInfoList.rooms.length != 0) {
          const tempRooms = new Array<PantryFridgeRoomCreateData>();
          for (const room of imageInfoList.rooms) {
            const images = new Array<PantryFridgeImageData>();
            for (const image of room.images) {
              const item = new PantryFridgeImageData(i, room.roomId, image, applianceId);
              images.push(item);
              i++;
            }
            const roomItem = new PantryFridgeRoomCreateData(
              room.roomId,
              images
            );
            NativeClient.sendDebugLog(
              "PantryCameraPage roomsList roomId=" + room.roomId + " result=" + JSON.stringify(roomItem)
            );
            tempRooms.push(roomItem);
          }
          for (let roomId = 0; roomId < MAX_FRIDGE_ROOM; roomId++) {
            let createRoomItem = null;
            const targetRoomId = (roomId == FRIDGE_ROOM_ID_TYPE.DOOR) ? FRIDGE_ROOM_ID_TYPE.FRIDGE : roomId;
            for (const data of tempRooms) {
              if (targetRoomId == data.roomId) {
                createRoomItem = data;
                break;
              }
            }
            let roomItem = null;
            if (createRoomItem != null) {
              switch(roomId) {
                case FRIDGE_ROOM_ID_TYPE.FRIDGE:
                  roomItem = getFridgeImageList(roomId, createRoomItem.images);
                  break;
                case FRIDGE_ROOM_ID_TYPE.DOOR:
                  roomItem = getDoorImageList(roomId, createRoomItem.images);
                  break;
                case FRIDGE_ROOM_ID_TYPE.FREEZER:
                  roomItem = getFreezerImageList(roomId, createRoomItem.images);
                  break;
                case FRIDGE_ROOM_ID_TYPE.VEGETABLE:
                  roomItem = getVegetableImageList(roomId, createRoomItem.images);
                  break;
              }
              let position = 0;
              if (roomItem != null) {
                const size = roomItem.areaMap.size;
                NativeClient.sendDebugLog(
                  "PantryCameraPage roomsList roomId=" + roomItem.roomId + " size=" + size
                );
                const areaIdList = PantryUtil.getAreaIdList(roomId, cameraRoomInfo.value.reizoDoorTypeId);
                if (areaIdList != null) {
                  for (const key of areaIdList) {
                    const areaData = roomItem.areaMap.get(key);
                    if (areaData && areaData.imageInfo) {
                      areaData.imageInfo.totalSize = size;
                      areaData.imageInfo.position = position;
                      areaData.imageInfo.roomId = roomId;
                      if (roomItem.areaMap != null) {
                        setImaegeMargin(areaData.imageInfo);
                      }
                      position++;
                    }
                  }
                }
                NativeClient.sendDebugLog(
                  "PantryCameraPage roomsList roomId=" + roomItem.roomId + " result=" + CommonUtil.jsonStringify(roomItem.areaMap)
                );
              }
            }
            if (roomItem == null) {
              roomItem = new PantryFridgeRoomData(
                roomId,
                new Map<number, Array<PantryFridgeImageData>>(),
                new Map<number, PantryFridgeImageData>()
              );
            }
            rooms.push(roomItem);
          }
        } else {
          for (let i = 0; i < MAX_FRIDGE_ROOM; i++) {
            const roomItem = new PantryFridgeRoomData(
              i,
              new Map<number, Array<PantryFridgeImageData>>(),
              new Map<number, PantryFridgeImageData>()
            );
            rooms.push(roomItem);
          }
        }
        NativeClient.sendDebugLog("PantryCameraPage roomsList rooms=" + JSON.stringify(rooms));
        // doorTypeId.value = reizoDoorTypeId;
        NativeClient.sendDebugLog("PantryCameraPage roomsList doorTypeId=" + JSON.stringify(cameraRoomInfo.value));
      }
      fridgeImageList.value = rooms;
    };

    /** ダイアログの制御 */
    const { closeDialog } = useApiErrorDialog();

    
    const requestFridgeList = async (applianceId: string) => {
      NativeClient.sendDebugLog("PantryCameraPage requestFridgeList applianceId=" + applianceId);
      await Promise.all([
        store.dispatch("pantry/getFridgeListInfo", applianceId)
      ]).then(result => {
        roomsList();
        updateDisplay();
        store.dispatch("common/stopLoading");
      }).catch(error => {
        NativeClient.sendDebugLog("PantryCameraPage requestFridgeList error " + JSON.stringify(error));
        NativeClient.showCameraCloseButton(false);
      });
    };

    const requestGetPantry = async () => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        NativeClient.sendDebugLog("PantryCameraPage requestGetPantry applianceId=" + applianceId);
        if (applianceId == null || applianceId == "") {
          store.dispatch("common/stopLoading");
          return;
        }
        requestFridgeList(applianceId);
      }).catch(error => {
        NativeClient.sendDebugLog("PantryCameraPage requestGetPantry error " + JSON.stringify(error));
        NativeClient.showCameraCloseButton(false);
      });
    };
    const onSelectRoom = (id: number) => {
      isShowCameraDateDialog.value = false;
      selectRoomId.value = id;
      updateDisplay();
    };

    const onSelectImage = (roomId: number, areaId: number, fileName: string) => {
      NativeClient.sendDebugLog("PantryCameraPage onSelectImage roomId=" + roomId + " areaId=" + areaId);
      const fridgeRoomId = PantryUtil.getFridgeRoomId(roomId);
      NativeClient.sendDebugLog("PantryCameraPage onSelectImage fridgeRoomId=" + fridgeRoomId + " areaId=" + areaId);
      NativeClient.transitionPantryZoom(fileName);
    };

    /*
     * レシピ詳細の取得を実行する
     */
    const execute = async () => {
      requestGetPantry();
    };

    const closeError = () => {
      closeDialog();
      NativeClient.showCameraCloseButton(true);
    };

    // const retryGetPantry = () => {
    //   closeDialog();
    //   NativeClient.showCameraCloseButton(true);
    //   if (fridgeImageList.value.length == 0) {
    //     execute();
    //   } else {
    //     updateDisplay();
    //   }
    // };

    const onShowDate = (roomId: number, areaId: number, selectId: number, list: Array<PantryCameraDateData>) => {
      NativeClient.sendDebugLog("PantryCameraPage onShowDate roomId=" + roomId + " areaId=" + areaId + " selectId=" + selectId + " dateList=" + JSON.stringify(list));
      dateRoomId.value = roomId;
      dateAreaId.value = areaId;
      dateSelectId.value = selectId;
      dateList.value = list;
      isShowCameraDateDialog.value = true;
      updateDateDialog();
    };

    const onSelectDate = (roomId: number, areaId: number, selectDateId: number) => {
      NativeClient.sendDebugLog("PantryCameraPage onSelectDate roomId=" + roomId + " areaId=" + areaId + " selectDateId=" + selectDateId);
      window.setTimeout(() => {
        isShowCameraDateDialog.value = false;
        let roomData = null;
        let i = 0;
        for (const room of fridgeImageList.value) {
          if (room.roomId == roomId) {
            roomData = room;
            break;
          }
          i++;
        }
        if (roomData) {
          const areaData = roomData.areaMap.get(areaId);
          if (areaData) {
            areaData.position = selectDateId;
            roomData.areaMap.set(areaId, areaData);
            fridgeImageList.value[i] = roomData;
            updateDisplay();
          }
        }
      }, WAIT_TIMER_DATE_CHANGE);
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      execute();
    });

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onUnmounted(async () => {
      // 画面から離れた場合
    });

    return {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      closeDialog,
      roomsList,
      fridgeImageList,
      onSelectRoom,
      selectRoomId,
      onSelectImage,
      onClickCloseCamera,
      applianceId,
      updateDisplayKey,
      updateListKey,
      isShowCameraDateDialog,
      dateRoomId,
      dateAreaId,
      dateList,
      dateSelectId,
      onSelectDate,
      onShowDate,
      updateDateDialogKey,
      closeError,
      ERROR_BUTTON_LABEL,
      cameraRoomInfo
    };
  }
});
